/**
 * The Vephus mark: the salamander — the creature that lives in the forge fire — on the dark tile
 * the app icon uses (docs/brand.md, docs/refactor/68-mascote.md). One head and four circles, drawn
 * rather than loaded, so it stays sharp at any size and carries its own ground on both themes.
 */
export default function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 1024 1024" role="img" aria-label="Vephus" style={{ flexShrink: 0, display: 'block' }}>
      <rect width="1024" height="1024" rx="224" fill="#121010" />
      <g transform="translate(512 512) scale(7.493) translate(-50 -52)">
        <path d="M50 36C68 36 84 45 88 58C91 69 82 79 68 80L32 80C18 79 9 69 12 58C16 45 32 36 50 36Z" fill="#C2410C" />
        <circle cx="29" cy="36" r="12" fill="#F97316" />
        <circle cx="71" cy="36" r="12" fill="#F97316" />
        <circle cx="29" cy="36" r="5.2" fill="#121010" />
        <circle cx="71" cy="36" r="5.2" fill="#121010" />
      </g>
    </svg>
  )
}
